import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, forkJoin, of, from } from 'rxjs';
import * as models from '../../shared/model/api';
import { isNil, isArray, isEmpty, get, maxBy, cloneDeep } from 'lodash';
import { SharedDataService } from './shared-data.service';
import { CurrencyPipe } from '@angular/common';
import {EnvironmentConfiguration} from '../../environment/services/environment.configuration'
import { ViewConstants } from '../../constants';
import * as moment from 'moment';
import { AuthServiceForgerock } from '../services/auth-service.service';
import { Store } from '@ngrx/store';
import * as fromWriteupsDetail from '../state';
import { getCreditData, getUserInfo } from 'src/app/core/state/selectors';
import { SubSink } from 'subsink';
import { IAppCoreState } from 'src/app/core/state';
import { DealDetailView } from 'src/app/shared/model/view-model/deal-detail-view';
import { getDealDetails } from 'src/app/feature/writeups-detail/state/selectors';
import { isObjectLike } from 'lodash';
import { AutorizationService } from './authorization-service';
import { DealUpdateWithPP } from 'src/app/feature/customer-view/state/actions/protection-products.action';
/**
 *  Class that is defined as Servive used to get Accessories, Packages, Dio's
 */
@Injectable( 
     {providedIn: 'root'}
)
export class SharedFunctionService {
    private creditData:any;
    private dealData:any;
  private vehicleType:string;
  public totalDealerInvoice: any;
  public acvPrice: any;
  private subs=new SubSink();


    constructor(
      private environment: EnvironmentConfiguration,
      private httpClient: HttpClient,
      public sharedDataService: SharedDataService,
      private autorizationService: AutorizationService,
      private authService : AuthServiceForgerock,
      private store:Store<IAppCoreState>,
      private _currencyPipe: CurrencyPipe,
      private _store: Store<fromWriteupsDetail.AppState>) {

    }
    keyPress(id) {
      let input = document.getElementById(id);
      input.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
          document.getElementById(id).click();
        }
      });
    }
    isArrayWithLength(o) {
        return isArray(o) && o.length > 0;
    }
    private _slicedToArray(arr, i) {
        return Array.isArray(arr) || this._iterableToArrayLimit(arr, i) || this._nonIterableRest();
    }
    private _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    private _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
    
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
    
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } catch (err) {
            // if (_d) throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        }
    
        return _arr;
      }
    replaceKeyValueWithString(o, obj) {
        var val = '';
    
        if (o.length > 0) {
          if (isObjectLike(obj)) {
            if (!Object.entries) {
              Object.entries = function (entObj) {
                var ownProps = Object.keys(entObj);
                var i = ownProps.length;
                var resArray = new Array(i);
    
                while (i--) {
                  resArray[i] = [ownProps[i], entObj[ownProps[i]]];
                }
    
                return resArray;
              };
            }
    
            val = o;
            Object.entries(obj).forEach(function (_ref) {
              var _ref2 = this._slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];
    
              var exp = new RegExp("".concat(key), 'i');
    
              if (exp.test(val)) {
                val = val.replace(exp, value);
              }
            });
          }
        }
    
        return val;
      }

  calculateDaysInStock(previousDaysInStock, invoiceDate, vehicleTradedDate) {
    let daysInStock = 0;
    let vinDaysInStock = (!isNil(previousDaysInStock) && !isNaN(parseInt(previousDaysInStock, 0))) ? previousDaysInStock : 0;
    let vinInvoiceDate = !isNil(invoiceDate) ? moment.utc(invoiceDate).format() : '';
    let vinVehicleTradedDate = !isNil(vehicleTradedDate) ? moment.utc(vehicleTradedDate).format() : '';
    let todaysDate = moment.utc().format();

    if (vinInvoiceDate.length > 0 && vinVehicleTradedDate.length > 0 && new Date(vinInvoiceDate) > new Date(vinVehicleTradedDate)) {
      daysInStock = Math.floor(moment.duration(moment(todaysDate).diff(moment(vinInvoiceDate))).asDays()) + parseInt(vinDaysInStock, 0);
    } else if (vinVehicleTradedDate.length > 0) {
      daysInStock = Math.floor(moment.duration(moment(todaysDate).diff(moment(vinVehicleTradedDate))).asDays()) + parseInt(vinDaysInStock, 0);
    } else if (vinInvoiceDate.length > 0) {
      daysInStock = Math.floor(moment.duration(moment(todaysDate).diff(moment(vinInvoiceDate))).asDays()) + parseInt(vinDaysInStock, 0);
    }

    if (!Number.isNaN(daysInStock)) {
      return String(daysInStock);
    } else {
      return "";
    }
  }
    /**
     * This method is used ot generate 64 bit hex id 
     */
    createUUID() {
        // http://www.ietf.org/rfc/rfc4122.txt
        let s = [];
        let hexDigits = '0123456789abcdef';
        const crypto= window.crypto;
        var array=new Uint32Array(1);
        for (let i = 0; i < 32; i++) {
            let randomValue= crypto.getRandomValues(array);
            s[i] = hexDigits.substr(Math.floor(Number(randomValue[0]/10000000000) * 0x10), 1);
        }
        // s[14] = '4';  // bits 12-15 of the time_hi_and_version field to 0010
        // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  
        // bits 6-7 of the clock_seq_hi_and_reserved to 01
        // s[8] = s[13] = s[18] = s[23] = '-';

        let uuid = s.join('');
        uuid = uuid.replace('-', '');
        return uuid;
    }

      /**
     * This method is used to set the credit range based on the value
     */
  populateCreditRangeArray() {
    this.subs.sink =
    this._store   
      .select(getDealDetails)
      .subscribe((dealDetail: DealDetailView) => {
        if (!isNil(dealDetail)) {
          this.dealData = dealDetail;
        }
        if(!isNil(this.dealData) && !isNil(this.dealData.dealData)&&
        !isNil(this.dealData.dealData.vehicle) && !isNil(this.dealData.dealData.vehicle.type)) {
          this.vehicleType = this.dealData.dealData.vehicle.type;
        }
      })
    let creditRangeArray = [];
    this.store.select(getCreditData).subscribe(data=>
        {
          this.creditData=data;
        });
        if(!isNil(this.creditData))
        {
        if(this.vehicleType?.toLowerCase()=="new")
        {
          let tempArray={};
          
          let temp=this.creditData['new'];
          temp.forEach(element => {
            tempArray={};
            tempArray["key"]=element.tier
            tempArray["value"]=element.score
            creditRangeArray.push(tempArray); 
          });
          temp.forEach(element => {
            tempArray={};
            tempArray["key"]=element.score
            tempArray["value"]=element.tier
            creditRangeArray.push(tempArray); 
          });
    
        }
        else if(this.vehicleType?.toLowerCase()=="certified")
        {
            let tempArray={};
            let temp=this.creditData['new'];
            temp.forEach(element => {
              tempArray={};
              tempArray["key"]=element.tier
              tempArray["value"]=element.score
              creditRangeArray.push(tempArray); 
            });
            temp.forEach(element => {
              tempArray={};
              tempArray["key"]=element.score
              tempArray["value"]=element.tier
              creditRangeArray.push(tempArray); 
            });
    
        }
        else if(this.vehicleType?.toLowerCase()=="used")
        {
            let tempArray={};
            let temp=this.creditData['new'];
            temp.forEach(element => {
              tempArray={};
              tempArray["key"]=element.tier
              tempArray["value"]=element.score
              creditRangeArray.push(tempArray); 
            });
            temp.forEach(element => {
              tempArray={};
              tempArray["key"]=element.score
              tempArray["value"]=element.tier
              creditRangeArray.push(tempArray); 
            });
        }
    }
        return creditRangeArray;

  }

  populateDeclinationCreditRangeArray(): { key: string, value: string }[] {
    const creditRangeArray = [
      { key: '720+', value: '1+' },
      { key: '690-719', value: '1' },
      { key: '670-689', value: '2' },
      { key: '650-669', value: '3' },
      { key: '630-649', value: '4' },
      { key: '610-629', value: '5' },
      { key: '580-609', value: '6' },
      { key: '<580', value: '7' }
    ];
    return creditRangeArray;
  }  

  formatCreditRange(creditRange: string) {
    let creditRangeArray = [];
    // if(!this.sharedDataService.setDealer)
     creditRangeArray = this.populateCreditRangeArray();
    // else if(this.sharedDataService.setDealer) creditRangeArray = this.populateCreditRangeArrayForSet();
    let value: string = '720+';
    if (creditRangeArray && creditRange) {
      let tempVal = creditRangeArray.filter(dt => dt.key === creditRange.toString());
      if (tempVal && tempVal.length > 0) {
        value = tempVal[0].value;
      }
    }
    return value;
  }

  formatDeclinationCreditRange(creditRange: string) {
    let creditRangeArray = this.populateDeclinationCreditRangeArray();
    let value: string = creditRange;
    if (creditRangeArray && creditRange) {
      let tempVal = creditRangeArray.filter(dt => dt.key === creditRange.toString());
      if (tempVal && tempVal.length > 0) {
        value = tempVal[0].value;
      }
    }
    return value;
  }

  formatDateWithSeperation(date: string, type: string, fromOrLastDate): string {
    let updatedDate = new Date(date);
    let year = updatedDate.getFullYear();
    let month = this.appendZeroToDate(updatedDate.getMonth() + 1);
    let day = this.appendZeroToDate(updatedDate.getDate());

    if (!fromOrLastDate) {
      if(type === '-') {
        return `${year}${type}${month}${type}${day}`;
      } else {
        return `${month}${type}${day}${type}${year}`;
      }
    } else if(fromOrLastDate) {
      if (fromOrLastDate == 'fromDate') {
        return this.formatDateWithSeperation(date, '-', null) + ' 00:00:00';
      } else {
        return this.formatDateWithSeperation(date, '-', null) + ' 23:59:59';
      }
    }
  }

    /**
     * this method is used to format and display the Date
     */
    formatDateWithHypenSeparatedMMDDYYYY(deskdate: string) {
       
       if(moment(deskdate, 'YYYY-MM-DD',true).isValid())
       {
        return moment(deskdate,'YYYY-MM-DD').format('MM-DD-YYYY');
       }
       else{
        let updatedDate = new Date(deskdate);
        let year = updatedDate.getFullYear();
        let month = this.appendZeroToDate(updatedDate.getMonth() + 1);
        let day = this.appendZeroToDate(updatedDate.getDate());
        return  month + '-' + day + '-' + year ;
       }
   
       
    }
//     /**
//      * this method is used to format and display the Date
//      */
    formatDateWithoutDotNewSeparated(date: string) {
        let updatedDate = new Date(date);
        let year = updatedDate.getFullYear();
        let month = this.appendZeroToDate(updatedDate.getMonth() + 1);
        let day = this.appendZeroToDate(updatedDate.getDate());
        return day + '' + month + '' + year;
    }

    /**
     * this method is used to format and display the Date
     */
    formatMonthDayYear(date: Date) {
        // let updatedDate = new Date(date);
        let year = date.getFullYear();
        let month = this.appendZeroToDate(date.getMonth() + 1);
        let day = this.appendZeroToDate(date.getDate());
        return  month + '-' + day + '-' + year;
    }

//     /**
//      * Method is used to add 0 for single digit numbers
//      */
    private appendZeroToDate(value: number): string {
        return value > 9 ? '' + value : '0' + value;
    }

    /**
     * Method is used to format the date value for MST
     */

    formatDateForLastModifiedDate(date?: string): string {
        let updatedDate: string = '-';
        if(!isNil(date)) {
            let actualDateTime = new Date(date + ' UTC');
            let day = this.formatDateValue(actualDateTime.getDate());
            let month = this.formatDateValue(actualDateTime.getMonth() + 1);
            let year = actualDateTime.getFullYear().toString().substr(-2);
            let hours = actualDateTime.getHours();
            let minutes = this.formatDateValue(actualDateTime.getMinutes());
            let h = (hours % 12) || 12;
            let ampm = hours < 12 ? 'AM' : 'PM';
            let timeString = this.formatDateValue(h) + ':' + minutes.toString() + ' ' + ampm;
            updatedDate = month + '/' + day + '/' + year + ' ' + timeString;
        }
        return updatedDate;
    }

    formatDateWithMMDDYYYYHHMMSS(date?: string): string {
        let updatedDate: string = '/';
        if(!isNil(date)) {
            let actualDateTime = new Date(date + ' UTC');
            let day = this.formatDateValue(actualDateTime.getDate());
            let month = this.formatDateValue(actualDateTime.getMonth() + 1);
            let year = actualDateTime.getFullYear().toString();
            let hours = actualDateTime.getHours();
            let minutes = this.formatDateValue(actualDateTime.getMinutes());
            let seconds = this.formatDateValue(actualDateTime.getSeconds());
            let timeString = this.formatDateValue(hours) + ':' + minutes.toString() + ':' + seconds.toString();
            updatedDate = month + '/' + day + '/' + year + ' ' + timeString;
        }
        return updatedDate;
    }


    formatDateWithMMDDYYYYHHMMSSHypen(date?: string): string {
        let updatedDate: string = '-';
        if(!isNil(date)) {
            let actualDateTime = new Date(date + ' UTC');
            let day = this.formatDateValue(actualDateTime.getDate());
            let month = this.formatDateValue(actualDateTime.getMonth() + 1);
            let year = actualDateTime.getFullYear().toString();
            let hours = actualDateTime.getHours();
            let minutes = this.formatDateValue(actualDateTime.getMinutes());
            let seconds = this.formatDateValue(actualDateTime.getSeconds());
            let timeString = this.formatDateValue(hours) + ':' + minutes.toString() + ':' + seconds.toString();
            updatedDate = month + '-' + day + '-' + year + ' ' + timeString;
        }
        return updatedDate;
    }

    /**
     * Method is used to format the date value for UTC
     */
    formatDateForUTCDate(date?: string): string {
        let updatedDate: string = '-';
        if(!isNil(date)) {
            let actualDateTime = new Date(date);
            let day = this.formatDateValue(actualDateTime.getDate());
            let month = this.formatDateValue(actualDateTime.getMonth() + 1);
            let year = actualDateTime.getFullYear().toString().substr(-2);
            let hours = actualDateTime.getHours();
            let minutes = this.formatDateValue(actualDateTime.getMinutes());
            let h = (hours % 12) || 12;
            let ampm = hours < 12 ? 'AM' : 'PM';
            let timeString = this.formatDateValue(h) + ':' + minutes.toString() + ' ' + ampm;
            updatedDate = month + '/' + day + '/' + year + ' ' + timeString;
        }
        return updatedDate;
    }
    formatDateWith12(date?: string): string {
        let updatedDate: string = '/';
        let ampm: string = '';
        if(!isNil(date)) {
          if(date.split(' ')[date.split(' ').length - 1] === 'AM' || date.split(' ')[date.split(' ').length - 1] === 'PM') {
            return date;
          } else {
            const actualDateTime = new Date(date + ' UTC');
            const day = this.formatDateValue(actualDateTime.getDate());
            const month = this.formatDateValue(actualDateTime.getMonth() + 1);
            const year = actualDateTime.getFullYear().toString();
            const hours = actualDateTime.getHours();
            const minutes = this.formatDateValue(actualDateTime.getMinutes());
            const seconds = this.formatDateValue(actualDateTime.getSeconds());
            const h = (hours % 12) || 12;
            ampm = hours < 12 ? 'AM' : 'PM';
            const timeString = this.formatDateValue(h) + ':' + minutes.toString() + ':' + seconds.toString() + ' ' + ampm;
            updatedDate = month + '/' + day + '/' + year + ' ' + timeString;
          }  
        }
        return updatedDate;
    }

     formatMessageTime(date) {
        let newDateTime=moment.utc(date).utcOffset("-06:00").format('YYYY-MM-DD HH:mm:ss').toString();
        return newDateTime.substring(0,newDateTime.length-12);
    }
    formatMessagesTime(date) {
        let newDateTime=moment.utc(date).utcOffset("-06:00").format('MM/DD/YYYY HH:mm:ss').toString();
        return newDateTime;
    }
    formatWriteUpsTime(date) {
        let newDateTime=moment.utc(date).utcOffset("-06:00").format('YYYY-MM-DD HH:mm:ss').toString();
        return newDateTime;
    }
    // formatTradeUpdatedDate(date) {
    //     let newDateTime=moment.utc(date).utcOffset("-06:00").format("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'").toString();
    //     return newDateTime;
    // }
    formatTradeUpdatedDate(date?: string): string {
        let updatedDate: string = '/';
        if(!isNil(date)) {
            let actualDateTime = new Date(date + ' UTC');
            let day = this.formatDateValue(actualDateTime.getDate());
            let month = this.formatDateValue(actualDateTime.getMonth() + 1);
            let year = actualDateTime.getFullYear().toString();
            let hours = actualDateTime.getHours();
            let minutes = this.formatDateValue(actualDateTime.getMinutes());
            let seconds = this.formatDateValue(actualDateTime.getSeconds());
            // let mseconds = this.formatDateValue(actualDateTime.getMilliseconds());
            let timeString = 'T' + this.formatDateValue(hours) + ':' + minutes.toString() + ':' + seconds.toString() + '.' + '000Z';
            updatedDate = year + '-' + month + '-' + day + '' + timeString;
        }
        return updatedDate;
    }

    /**
     * Method used to format the date value (if the value is less
     * than 9 then will 0 before the value)
     */
    private formatDateValue(value) {
        return value > 9 ? '' + value : '0' + value;
    }
    /**
     * Method used to convert the normal price to currency price
     */
    convertToCurrencyPrice(value) {
        return new CurrencyPipe(ViewConstants.EN_US)
            .transform(value, ViewConstants.USD, true, '1.2');
    }
    /**
     * Method used to convert the currency  price to normal price
     */
    convertToNormalPrice(value) {
      if(value !== '' && !isNil(value) && value !== undefined){
      value = value.replace('$', '');
        let modifiedValue=parseFloat(value
            .replace(ViewConstants.USD_SYMBOL, ViewConstants.EMPTY_STRING)
            .replace(/,/g, ViewConstants.EMPTY_STRING))
        return modifiedValue;
      }
    }
    /**
     * Method to see if trade ins have amount > 0
     */
    tradeInValuesValidate(tradeIns: Array<models.TradeIn>) {
        let isAllTradeInAvailable: boolean = false;
        if (!isNil(tradeIns) && tradeIns.filter(dt =>
            //dt.applyToDeal && (isNil(dt.tradeInAmount) || dt.tradeInAmount < 0)).length === 0) {
            // dt.applyToDeal && ((isNil(dt.tradeInAmount) || dt.tradeInAmount < 0) && (isNil(dt.dealerTradeInAmount) || dt.dealerTradeInAmount < 0))).length === 0) {
            dt.applyToDeal && ((isNil(dt.dealerTradeInAmount) || dt.dealerTradeInAmount < 0))).length === 0) {
            isAllTradeInAvailable = true; 
        }
        return isAllTradeInAvailable;
    }
    /**
     * Method to see if trade ins with and without apply flag have amount > 0
     */
    tradeInValuesWithoutapplyValidate(tradeIns: Array<models.TradeIn>) {
      let isAllTradeInWitoutApplyAvailable: boolean = false;
      if (!isNil(tradeIns) && tradeIns.filter(dt =>
          //dt.applyToDeal && (isNil(dt.tradeInAmount) || dt.tradeInAmount < 0)).length === 0) {
          // dt.applyToDeal && ((isNil(dt.tradeInAmount) || dt.tradeInAmount < 0) && (isNil(dt.dealerTradeInAmount) || dt.dealerTradeInAmount < 0))).length === 0) {
          ((isNil(dt.dealerTradeInAmount) || dt.dealerTradeInAmount < 0))).length === 0) {
          isAllTradeInWitoutApplyAvailable = true; 
      }
      return isAllTradeInWitoutApplyAvailable;
  }

    // Logout
    logout(windowInstance: any): void {
        this.authService.logout();
        windowInstance.sessionStorage.clear();
        windowInstance.localStorage.removeItem(ViewConstants.REFRESH_TOKEN_INVOKED);
        windowInstance.localStorage.removeItem('cv_queryString');
        windowInstance.location.href = this.environment.SILENT_REDIRECT_URL;
        
    }

    expiredDate(existingDate:string, currentDate:string){
        if(existingDate && (currentDate > existingDate)){
                return true;
            }
            else{
                return false;
            }
    }

    // /**
    //  * This method for generate random alphanumeric character
    //  * @param charLenght 
    //  */
    public generateAlphaNumeric(charLenght:number) {
        let possible = "abcdefghijklmnopqrstuvwxyz0123456789";
        let text:string = "";
        const crypto= window.crypto;
        var array=new Uint32Array(1);
        for (let i = 0; i < charLenght; i++) {
            let randomValue= crypto.getRandomValues(array);
            text += possible.charAt(Math.floor(Number(randomValue[0] / 10000000000) * possible.length));
        }
        return text;
    }

    /**
     * DescOrderDate Function for descending the date the array based on date
     * @param tradinArray
     */
    public descOrderDate(tradinArray: Array<models.TradeIn>) {
        tradinArray.sort((IndexOne: models.TradeIn, IndexTwo: models.TradeIn) => {
            let firstDate = new Date(IndexOne.updatedDate)
            let secoundDate = new Date(IndexTwo.updatedDate)
            return secoundDate.getTime() - firstDate.getTime();
        });
        return tradinArray;
    }

    /**
     * Convert date returned from backend api to proper time zone.
     * 
     * Date at server is kept in UTC format but current api doesnt send the complete date string to the 
     * client. it omits the timezone part. ending up to mis-calculation when converting.
     * 
     * This method will simply add a ` UTC` to the end of the date string and
     * return the date in browser's timezone    
     * 
     * @param raw string representation of the date coming from the api
     * @returns date object in the browser time zone
     */
    public parseApiDate(dateString : string) :Date {
        
        if(dateString){            
           return new Date(dateString + ' UTC');
        }        
        return null;
    }
    public _formatDateColumn(input: string, isDownload?) {
      let output: string = '';
      let date: string = '';
      let time: string = '';
      if (input) {
        input =moment(input).format('MM/DD/YYYY HH:mm:ss');
        const inputDate = new Date(input);
        inputDate.setMinutes(inputDate.getMinutes() - new Date().getTimezoneOffset())
        const today = new Date();
        const dateTime = inputDate.toLocaleString('en-US').split(',');
        if (inputDate.toDateString() == today.toDateString() && !isDownload) {
          date = 'Today'
        }
        else {
          date = dateTime[0];
        }
        time = dateTime[1]
        if(isDownload)
          output = `${date} \r ${time}`;
        else output = `${date}<br /><span>${time}</span>`;
      }
      return output;
    }

    removeDuplicate(dataArr) {
        const resultArr = dataArr.filter((data,index)=>{
            return dataArr.indexOf(data) === index;
        });
        return resultArr;
    }

    ppMonthlyPayment(name, addons) {
        const resultArr = addons.filter(dt=> dt && dt.name.indexOf(name) > -1);
        // const resultArr = addons.filter(dt=> dt && dt.name.includes(retailCost) && dt.name.includes(product));
        return (resultArr && resultArr.length > 0 ) ? resultArr[0].monthlyPayment : null;
    }

    setAccessories(dt, retailCost, name, dtype, leaseType) {

        const accessoriespp: models.DealerAddOnsPP = {};
        if(leaseType !== 'regular' && dtype.indexOf('lease') > -1) accessoriespp.capitalized = true;
        else accessoriespp.capitalized = dt['isCapitalized'];
        accessoriespp.taxable = dt['isTaxable'];
        accessoriespp.salePrice = retailCost;
        accessoriespp.type = 'PP';
        accessoriespp.residualValue = 0;
        accessoriespp.name = name;
        return accessoriespp;
    }
    formatLogData(logData:any[]){
      return logData.map(log => {
        if(!isNil(log) && log.eventDetails){
          const logEventDetails = log.eventDetails;
          log.eventDetails = logEventDetails.join('\n'); //Used for Log PDF.
          log['eventDetailsTemplate'] = logEventDetails.map(led => `<p>${led}</p>`).join(''); //Used for Log Grid.
          return log;
        }
      }).map((log, index) =>{
          if(!isNil(log)){
            const logObjectProps = Object.keys((log));
            logObjectProps.forEach(prop =>{
                const propValue = log[prop];
                if(/^[\d]+$/.test(new String(propValue).replace('.', ''))){
                    log[prop] = new CurrencyPipe(ViewConstants.EN_US)
                    .transform(propValue, ViewConstants.USD, true, '1.2');
                }
            })
            log['timeStamp'] = new Date(log.timeStamp).toLocaleString().replace(',', '');
          }
          return log;
      });
  }

  getDealerCategory(type:any, dealerCategory:any, dealerSubCategory:any, incomplete:any, promoteStatus:any,
    certification:any){
    if(type =="new"){
      if((dealerCategory === 'H') || (dealerCategory === 'G' && dealerSubCategory === 'S'))
          return false;
      else return true;
    }
    if(type== "used"){
      if(!incomplete && dealerCategory !== 'A')
      return true;
      else if(!incomplete && dealerCategory === 'A'  && promoteStatus && promoteStatus.toLowerCase() === 'online')
       return true;
      else return false; 
    }
     if(type== "certified"){
      if(certification.toLowerCase() !== "certified")
      return false;
      else if(!incomplete && dealerCategory !== 'A')
      return true;
      else if(!incomplete && dealerCategory === 'A'  && promoteStatus && promoteStatus.toLowerCase() === 'online')
       return true;
      else return false; 
    }
  }

  readMilesPerYear(miles: number, rebateResponse: any){
    let defaultMileage;
    if(miles > 0){
      defaultMileage = miles;
    }else{
      defaultMileage = rebateResponse?.defaultMileage;
    }
    return{
      defaultMileage: defaultMileage,
      defaultMileageOptions: rebateResponse?.defaultMileageOptions
    }
  }

  readupFrontFlag(dealDataUpFrontFlag:any, rebateResponseUpFrontFlag:any){
    let upfrontFlags ={};
    if(Object.keys(dealDataUpFrontFlag).length >0){
      upfrontFlags = dealDataUpFrontFlag;
    }else{
      upfrontFlags['cashDown'] = rebateResponseUpFrontFlag['ApplyCashDownToUpfront'],
      upfrontFlags['rebate']  = rebateResponseUpFrontFlag['ApplyRebateToUpfront'],
      upfrontFlags['tradeIn'] = rebateResponseUpFrontFlag['ApplyNetTradeToUpfront']
    }
    return{
      upfrontFlags
    }
  }

  getSellingPrice(vehicle, type) {
    let result = 0;
    if (isNil(type) || type?.toLowerCase() === 'new') {
    if(this.sharedDataService.dealerCode === vehicle.dealerCd || this.sharedDataService.new_pooled_dealers.includes(vehicle.dealerCd)) {
      if ((vehicle.price.advertizedPrice || vehicle.price.advertisedPrice) && this.sharedDataService.defaultSP === 'Adv Price') {
        result = vehicle.price.advertizedPrice ? vehicle.price.advertizedPrice : vehicle.price.advertisedPrice;
      } else if (vehicle.price.sellingPrice && this.sharedDataService.defaultSP === 'Selling Price') {
        result = vehicle?.price?.sellingPrice;
      } else {
        result = vehicle.price.totalMsrp + this.totalDIO(vehicle.options);
      }
    } else {
      result = vehicle.price.totalMsrp + this.totalDIO(vehicle.options);
    }
    } else {
      let price = null;
      if (vehicle.price !== undefined && vehicle.price['retailAmount'] !== undefined) {
        price = Number(vehicle.price['retailAmount']);
      }
      result = price;
    }

    return result;
  }

  totalDIO(options) {
    if(options?.length > 0) {
      let dios = 0;
        options.forEach((op,i)=>{
          if(options[i]?.dealerSellingPrice) dios = dios + options[i]?.dealerSellingPrice;
        });
      return dios;
    } else return 0
  }
  
  objectKeys(grossProfit){
    if(grossProfit && Object.keys(grossProfit).length >0)
    return true
    else return false;
  }

  objectKeysGrossFrontEnd(grossProfit){
    if(grossProfit && Object.keys(grossProfit).length >0 && grossProfit?.frontEnd && Object.keys(grossProfit?.frontEnd).length >0)
    return true
    else return false;
  }

  objectKeysGrossBackEnd(grossProfit){
    if(grossProfit && Object.keys(grossProfit).length >0 &&  grossProfit?.backEnd && Object.keys(grossProfit?.backEnd).length >0)
    return true
    else return false;
  }
  enableOrDisableTabing(tabindex: string){
    const tabAbleElements = document.querySelectorAll("*[tabindex], input, select, button, a, textarea");
    tabAbleElements.forEach(elt => elt.setAttribute('tabindex', tabindex));
  }

  getSelectedLender(dealData){
    let selectedLender;
    const term = !isEmpty(dealData?.dealData?.approvedOffer) ? dealData?.dealData?.approvedOffer?.totalMonths: dealData?.dealData?.estimatedOffer?.totalMonths;
    const arrays = dealData?.estimatePaymentGrid?.filter(obj=> obj?.selectedTerm == term);
    if(arrays && arrays[0]?.lender?.length === 1)
    selectedLender= arrays[0].lenderSelected[dealData?.estimatePaymentGrid?.findIndex(obj=> obj?.selectedTerm == term)]
    else if(arrays && arrays[0]?.lender?.length == 0)
    selectedLender= ''; 
    else if (arrays && arrays[0]?.lender?.length > 1){
      selectedLender= dealData?.estimatePaymentGrid?.find(obj=> obj?.selectedTerm == term)?.lenderSelected[dealData?.estimatePaymentGrid?.findIndex(obj=> obj?.selectedTerm == term)];   
    }
    return selectedLender;
  }

  getQuoteCalculatorTransactionId(aprDetails, dealData, selectedDealType, selectedPaymentGridData){
    let paymentArray;
    let paymentResponseCashDownArray;
    if (aprDetails && aprDetails.length > 0 && aprDetails[0] !== null) {
      paymentResponseCashDownArray = aprDetails[0]?.['aprDetails']?.[selectedDealType]?.[selectedPaymentGridData];
    }
    const term = dealData?.dealData?.approvedOffer?.totalMonths;
    const selectedLender = this.getSelectedLender(dealData);
    if(selectedLender =='' || selectedLender == undefined)
    paymentArray = paymentResponseCashDownArray?.filter(row =>row.term == term);
    else
    paymentArray= paymentResponseCashDownArray?.filter(row =>row.term == term && row?.lender?.name ==selectedLender);
     return paymentArray;

  }

  quoteCalculatorTransIdNewVehicleInititedModal(data, paymentResponse){
     //if pricegrid is availble from  isSelected true array get type term and lender
     // if no pricegrid get the term and type from estimated offers block and landing on first lender
     if(data?.priceGrid?.details && data?.priceGrid?.details?.length >0){
      const selectedData=  data?.priceGrid?.details.filter(each => each.isSelected);
      let finalArray;
      let type;
      if(selectedData.length >=1){
        type = selectedData[0]?.type == 'finance'? 'retail': selectedData[0].type == 'lease' ?'lease':'cash';
      }
      else{
        type = data?.paymentType == 'APR'? 'retail': data?.paymentType  === 'LEASE'?'lease':'cash';
      }
      if(type=='cash' || type=='CASH')
      {
        return paymentResponse[type][0][0];
      }
      let cashDownArray = paymentResponse[type][data?.estimatedOffer?.cashDown]?.filter(each => each?.term == selectedData[0]?.term);
      if(selectedData &&  selectedData[0] && selectedData[0]?.lender){
        finalArray = cashDownArray.filter(each => each.lender.displayName + each.lender.name  == selectedData[0].lender.displayName + selectedData[0].lender.name)
        }
      else{
        finalArray = cashDownArray;
      }
      return finalArray && finalArray[0];
    }
    else{
      const type = data?.estimatedOffer?.dealtype == 'finance'? 'retail': data?.estimatedOffer?.dealtype == 'lease' ?'lease':'cash';
      let cashDownArray = paymentResponse[type][data?.estimatedOffer?.cashDown]?.filter(each => each.term == data?.estimatedOffer?.totalMonths);
      return cashDownArray[0];
    }
  }

  public getVspecurl(data):Observable<any>{
    const path = this.environment.MST_BASE_SERVICE_URL + `user/${this.sharedDataService.dealerCode}/share/${data.shareConfigDetails.vin}?type=${data.shareConfigDetails.type}&shortUrl=${data.shareConfigDetails.shortUrlStatus}`;       
    return this.httpClient.post(path,data.dealDetails);
  
}
handleErrorDetail(error) {
  let errorMessage = '';
  if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
  } else {
      // server-side error            
      if (error.error instanceof Object) errorMessage = (typeof error.error.errorDesc!=undefined && error.error.errorDesc!=null)?error.error.errorDesc:"Service Error";
      else errorMessage = error.error;
  }
  return throwError(errorMessage);
}

  getCarImgUrl(vehicleDetails): string {
    let media: any = [];
    if (vehicleDetails?.media?.length > 0) {
      if (!vehicleDetails?.certificationStatus) {
        if (vehicleDetails?.brand === ViewConstants.LEXUS) {
          media = vehicleDetails.media.find(item => item.size === '700_645_PNG' && item.imageTag === 'Drivers side profile');
        } else {
          media = vehicleDetails.media.find(item => item.size === '864_477_PNG' && item.imageTag === 'DS profile');
        }
        if (media?.href) {
          return media.href;
        }
      }

      media = [...vehicleDetails.media]; //doesn't mutate the original array
      if (media?.length > 0) {
        const sortOrder = [ ViewConstants.EXTERIOR.toLowerCase(), 'other', ViewConstants.INTERIOR.toLowerCase()]; //sorting order

        //to get the sorting index as other if type is not exterior or interior
        const sortOrderIndex = type => (type !== ViewConstants.EXTERIOR.toLowerCase() && type !== ViewConstants.INTERIOR.toLowerCase()) ? sortOrder.indexOf('other') : sortOrder.indexOf(type);

        // if value is not present at the end(_1.jpg), then give max(99) value so that it will go to end of the sort.
        const getIndexNum = (url) => {
          const index = Number(url?.split('_')?.pop()?.split('.')?.[0]);
          return isNaN(index) ? 99 : index;
        };

        //sort the media first in the order of exterior, other and interior. after that each section will be sorted based on the index(_1.jpg) of the url.
        media.sort((a, b) => (sortOrderIndex(a.type) - sortOrderIndex(b.type)) || getIndexNum(a.href) - getIndexNum(b.href));

        return media.length > 0 ? media[0].href : '';
      }
    }
    return '';
  }

  getCarJellyImgUrl(vehicleDetails): string {
    return vehicleDetails?.media?.find(item => item?.type?.toLowerCase() === 'carjellyimage')?.href;
  }

  getPayloadForOCA(dealData, appTypeCode) {
    let payload: any = dealData;
    payload.dealerType = this.autorizationService.brand?.toLocaleLowerCase() === 'lexus' ? 'Lexus' : 'Toyota';
    payload.dealerBaseUrl = this.sharedDataService.dealerbaseUrl;
    payload.debugInfo = {};
    payload.debugInfo.date = new Date().toUTCString();
    payload.debugInfo.dealTransactionId = dealData?.dealTransactionId,
    payload.debugInfo.sender = "CON";
    this.sharedDataService.regionCode.subscribe(val => {
      payload.regionCode = val;
    })
    this.subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
      if (userInfo) {
        payload.debugInfo.salesAssociateName = userInfo.first_name + ' ' + userInfo.last_name;
        payload.debugInfo.salesAssociateUserId = userInfo.UserId;
      };
    });

    payload.ocaData = this.constructOcaObject(dealData, appTypeCode);

    return payload;
  }

  constructOcaObject(dealData, appTypeCode) {
    let ocaData: any = {};

    if (!this.sharedDataService.setDealer) {
      ocaData.channelId = 'MST';
      ocaData.dealershipCountry = this.sharedDataService.dealerPostalAddress?.countryID ?? "";
    }

    ocaData.dealershipName = this.sharedDataService.dealerName;
    ocaData.dealershipAddress = this.sharedDataService.dealerAddress?.split(',')[0] ?? "";
    ocaData.dealershipCity = this.sharedDataService.dealerPostalAddress?.cityName?.value ?? "";
    ocaData.dealershipState = this.sharedDataService.dealerPostalAddress?.stateOrProvinceCountrySubDivisionID?.value ?? "";
    ocaData.dealershipZip = this.sharedDataService.dealerPostalAddress.postcode.value ?? "";
    ocaData.dealershipPhone = this.sharedDataService.dealerPhoneNo ?? "";
    ocaData.dealershipContactName = this.sharedDataService.loggedInUserName ?? "";
    ocaData.dealershipEmail = this.sharedDataService.dealerEmail ?? "";
    ocaData.acvOrInvoice = this.constructAcvOrInvoiceValue(dealData);
    if(appTypeCode && appTypeCode === 'B') {
      ocaData.appTypeCode = appTypeCode;
    }

    return ocaData;
  }

  constructAcvOrInvoiceValue(dealData) {
    if(this.dealData) {
      if (this.dealData?.dealData?.vehicle?.type != undefined && this.dealData?.dealData?.vehicle?.type != null && this.dealData?.dealData?.vehicle?.type != '') {
        if (this.dealData?.dealData?.vehicle?.type?.toLowerCase() == 'new') {
          if (this.dealData?.vehicleServiceResponse?.price?.totalDealerInvoice) {
            return this.dealData?.vehicleServiceResponse?.price?.totalDealerInvoice
          }
        } else if (this.dealData?.vehicleServiceResponse?.price?.acvPrice) {
          return (this.dealData?.vehicleServiceResponse?.price?.acvPrice != '') ? Number(this.dealData?.vehicleServiceResponse?.price?.acvPrice) : "";
        }
      } else if (this.dealData?.vehicleServiceResponse?.price?.totalDealerInvoice) {
        return this.dealData?.vehicleServiceResponse?.price?.totalDealerInvoice;
      }
    } else {
          if (dealData?.vehicle?.type != undefined && dealData?.vehicle?.type != null && dealData?.vehicle?.type != '') {
            if (dealData?.vehicle?.type?.toLowerCase() == 'new') {
              return Number(this.totalDealerInvoice) ?? ""
            } else if (this.acvPrice) {
              return (this.acvPrice != '') ? Number(this.acvPrice) : "";
            }
          } else if (this.totalDealerInvoice) {
            return Number(this.totalDealerInvoice) ?? "";
          }
    }
  }
  formatDealStatus(deal: any): string{
    let dealStatus;
    switch(deal?.status?.toLowerCase()){
        case 'SENT TO FINANCE'.toLowerCase(): dealStatus = ViewConstants.DEAL_STATUS_SENT_TO_FINANCE; break;
        case 'INITIATED'.toLowerCase(): dealStatus = ViewConstants.INITIATED; break;
        case 'FINALIZED'.toLowerCase(): dealStatus = ViewConstants.DEAL_STATUS_FINALIZED; break;
        case 'WRITE-UP PRICED'.toLowerCase(): dealStatus = ViewConstants.WRITE_UP_PRICIED; break;
        case 'DEALER APPROVED'.toLowerCase(): dealStatus = ViewConstants.APPROVED_MST; break;
        case 'TRADE APPROVED'.toLowerCase(): dealStatus = ViewConstants.TRADE_APPROVED_MST; break;
        case 'PENDING REVIEW'.toLowerCase(): dealStatus = ViewConstants.PENDING_APPROVAL_MST; break;
        case 'EXPIRED'.toLowerCase(): dealStatus = ViewConstants.EXPIRED_MST; break;
        case 'CANCELLED'.toLowerCase(): dealStatus = ViewConstants.CANCELLED_MST; break;
        case 'DFI SUBMITTED'.toLowerCase(): dealStatus = ViewConstants.DFI_SUBMITTED; break;
        case ViewConstants.DEAL_STATUS_CONTRACT_APPROVED.toLowerCase(): dealStatus = ViewConstants.DEAL_STATUS_CONTRACT_APPROVED; break;
        default: dealStatus = deal.status; break;
    }
    if (deal?.status?.indexOf('_') > 0) dealStatus = dealStatus.replace('_', ' ');
        return dealStatus;
  }
  getTotalTradeInValue(calculatedDataArray){
    const totalTradeValue = calculatedDataArray.aprDetails.request.tradeInVehicle.map(tradeIn => tradeIn.allowance).
    reduce((value1, value2) => value1 + value2, 0);
    const totalPayoffValue = calculatedDataArray.aprDetails.request.tradeInVehicle.map(tradeIn => tradeIn.payoff).
    reduce((value1, value2) => value1 + value2, 0);
    return {totalTradeIn: totalTradeValue - totalPayoffValue, payoff: totalPayoffValue, tradeAllowance: totalTradeValue};
}
  getPricingTableDetails(dealDetails, leaseType){
    let secGrid = dealDetails.secGridData,dataGrid = [],milesPerYear = dealDetails.milesPerYear,selctedMonthly = "",selectedFincanceTerm;
    let selectedFincanceRate,selectedLeaseTerm,leaseVehicleSellingPrice="",financeVehicleSellingPrice="",amountDueAtSigning = "";
    let selectedRow = 0,selectedLender ='',highlightedIndex = 0;
    if (!isNil(secGrid) && secGrid.length > 0) {
      secGrid.map(dt => {
          if (!isNil(dt) && dt.dTypePdf === 'finance') {
              dataGrid = dt.estimatePdf;
          }
          if (!isNil(dt) && dt.dTypePdf === 'lease') {
              dataGrid = dt.estimatePdf;
              milesPerYear=dt.milesPerYear!=0?dt.milesPerYear:dealDetails.milesPerYear;
          }
      });
    }
    dealDetails.secGridData.forEach(item => {
      if (item.dTypePdf == "finance") {
          item.estimatePdf.forEach((item,i) => {
              if (item.highlightColumnName != null) {
                  if(item['vehicleSellingPrice'+(i+1)]){
                      financeVehicleSellingPrice=item['vehicleSellingPrice'+(i+1)]
                  }
                  selectedFincanceTerm = item.selectedTerm;
                  selectedFincanceRate = Math.floor(item.selectedRate * 100) / 100;
              }
          })
      }
      else if (item.dTypePdf == "lease") {
          item.estimatePdf.forEach((item,i) => {
              if (item.highlightColumnName != null) {
                  if(item['vehicleSellingPrice'+(i+1)]){
                      leaseVehicleSellingPrice=item['vehicleSellingPrice'+(i+1)]
                  }
                  if(item['vehicleSellingPrice1'] && (leaseType === ViewConstants.ONE_PAY_LEASE||  leaseType === 'zero')){
                      leaseVehicleSellingPrice=item['vehicleSellingPrice1']
                  }
                  selectedLeaseTerm = item.selectedTerm;
              }
          })
      }
    })
    dataGrid.forEach(dataRow => {

      if (!isNil(dataRow) && dataRow.selectedTerm != null) {
          if (dataRow.highlightColumnName == 'monthlyPayment1') {
              selectedRow = 0;
              if(leaseType !== ViewConstants.ONE_PAY_LEASE || this.sharedDataService.isActiveTab.includes('finance'))
                  selctedMonthly = this._formatPrice(dataRow.monthlyPayment1 ? dataRow.monthlyPayment1.toString() : 'N/A')
              else
                  selctedMonthly = this._formatPrice(dataRow.dueAtSigning1 ? dataRow.dueAtSigning1.toString() : 'N/A')
              amountDueAtSigning = this._formatPrice(dataRow.dueAtSigning1 ? dataRow.dueAtSigning1.toString() : 'N/A')
          }
          if (dataRow.highlightColumnName == 'monthlyPayment2') {
              selectedRow = 1;
              selctedMonthly = this._formatPrice(dataRow.monthlyPayment2 ? dataRow.monthlyPayment2.toString() : 'N/A')
              amountDueAtSigning = this._formatPrice(dataRow.dueAtSigning2 ? dataRow.dueAtSigning2.toString() : 'N/A')

          }
          if (dataRow.highlightColumnName == 'monthlyPayment3') {
              selectedRow = 2;
              selctedMonthly = this._formatPrice(dataRow.monthlyPayment3 ? dataRow.monthlyPayment3.toString() : 'N/A')
              amountDueAtSigning = this._formatPrice(dataRow.dueAtSigning3 ? dataRow.dueAtSigning3.toString() : 'N/A')

          }
      }

    });
    return{
      secGrid,dataGrid,milesPerYear,selctedMonthly,selectedFincanceTerm,selectedFincanceRate,selectedLeaseTerm,leaseVehicleSellingPrice,financeVehicleSellingPrice,amountDueAtSigning,selectedRow
    }
  }
  _formatPrice(number: any): string {
    if(isNil(number)) number = 'N/A';
    const price: string = (number !== 'N/A') ? this._currencyPipe.transform(Number(number), 'USD', 'symbol', '1.2-2') : number;
    return `${price}`;
  }
  getDefaultPlanDetails(element, totalMonths, dealType) {
    const product:any = {};
    if(!element.isTermBased) { // is not isTermBased
      if (element.dealerDefaults && element.dealerDefaults.length > 0) { // dealerDefaults is not empty
        if(dealType?.toLowerCase() !== ViewConstants.DEAL_TYPE_CASH.toLowerCase()) {
          let matched = false;
          let planMatched = false;
          element.dealerDefaults.forEach((dealerDefault, index) => {
            if (totalMonths === dealerDefault.maxTerm || totalMonths === dealerDefault.minTerm || (totalMonths > dealerDefault.minTerm && totalMonths < dealerDefault.maxTerm)) {
              matched = true; 
              const defaultForm = element.form.filter(el => el.isDefault)[0];
                defaultForm.plans.forEach(plan => {
                  if (dealerDefault.planId === plan.planId && plan.showPlanToCustomer) {
                    planMatched = true;
                    product.formId = defaultForm.id;
                    product.selectedPlan = plan;
                    product.coverage = plan.displayName;
                    product.planCode = plan.planId;
                    product.planName = plan.planName;
                    let matchedCoverages;
                    if(!dealerDefault.selectedDeductible) {
                        matchedCoverages = plan.coverageOptions.filter(el => el.timeMileage === dealerDefault.selectedTimeMileage);
                        if(matchedCoverages.length === 1) {
                          product.timeMileage = get(matchedCoverages[0], 'timeMileage', null);
                          product.deductible = get(matchedCoverages[0], 'deductible', null);
                          product.displayTimeMileage = get(matchedCoverages[0], 'displayTimeMileage', null);
                        } else if(matchedCoverages.length > 1) {
                          const maxDeduct = maxBy(matchedCoverages, 'deductible');
                          product.timeMileage = get(maxDeduct, 'timeMileage', null);
                          product.deductible = get(maxDeduct, 'deductible', null);
                          product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
                        } else {
                          product.timeMileage = get(plan, 'coverageOptions[0].timeMileage', null);
                          product.deductible = get(plan, 'coverageOptions[0].deductible', null);
                          product.displayTimeMileage = get(plan, 'coverageOptions[0].displayTimeMileage', null);
                        }
                    } else if(dealerDefault.selectedDeductible && dealerDefault.selectedTimeMileage) {
                      matchedCoverages = plan.coverageOptions.filter(el => (el.deductible === dealerDefault.selectedDeductible) && (el.timeMileage === dealerDefault.selectedTimeMileage));
                      product.timeMileage = get(matchedCoverages[0], 'timeMileage', null);
                      product.deductible = get(matchedCoverages[0], 'deductible', null);
                      product.displayTimeMileage = get(matchedCoverages[0], 'displayTimeMileage', null);
                    } else {
                      const maxDeduct = maxBy(plan.coverageOptions, 'deductible');
                      product.timeMileage = get(maxDeduct, 'timeMileage', null);
                      product.deductible = get(maxDeduct, 'deductible', null);
                      product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
                    }
                  }
                })

              if (!planMatched) { // If the plan from dealer defaults is not matching with any plans from the form then pick default 
                const defaultForm = element.form.filter(el => el.isDefault)[0];
                const defaultPlan = defaultForm.plans.filter(el => el.showPlanToCustomer);
                let maxDeduct = maxBy(defaultPlan[0].coverageOptions, 'deductible');
                if (!maxDeduct) {
                  maxDeduct = defaultPlan[0].coverageOptions[0];
                }
                product.formId = defaultForm.id;
                product.selectedPlan = defaultPlan[0];
                product.coverage = defaultPlan[0].displayName;
                product.planCode = defaultPlan[0].planId;
                product.planName = defaultPlan[0].planName;
                product.timeMileage = get(maxDeduct, 'timeMileage', null);
                product.deductible = get(maxDeduct, 'deductible', null);
                product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
              }
            } 
            if(index === element.dealerDefaults.length - 1) {
              if(!matched) {
                const defaultForm = element.form.filter(el => el.isDefault)[0];
                const defaultPlan = defaultForm.plans.filter(el => el.showPlanToCustomer);
                let maxDeduct = maxBy(defaultPlan[0].coverageOptions, 'deductible');
                if (!maxDeduct) {
                  maxDeduct = defaultPlan[0].coverageOptions[0];
                }
                product.formId = defaultForm.id;
                product.selectedPlan = defaultPlan[0];
                product.coverage = defaultPlan[0].displayName;
                product.planCode = defaultPlan[0].planId;
                product.planName = defaultPlan[0].planName;
                product.timeMileage = get(maxDeduct, 'timeMileage', null);
                product.deductible = get(maxDeduct, 'deductible', null);
                product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
              }
            }
          })
        } else if(dealType?.toLowerCase() === ViewConstants.DEAL_TYPE_CASH.toLowerCase()) {
          let planMatched = false;
          const defaultForm = element.form.filter(el => el.isDefault)[0];
          product.formId = defaultForm.id;
          defaultForm.plans.forEach(plan => {
              if (element.dealerDefaults[0].planId === plan.planId && plan.showPlanToCustomer) {
                planMatched = true;
                product.selectedPlan = plan;
                product.coverage = plan.displayName;
                product.planCode = plan.planId;
                product.planName = plan.planName;
                let matchedCoverages;
                  if(!element.dealerDefaults[0].selectedDeductible) {
                      matchedCoverages = plan.coverageOptions.filter(el => el.timeMileage === element.dealerDefaults[0].selectedTimeMileage);
                      if(matchedCoverages.length === 1) {
                        product.timeMileage = get(matchedCoverages[0], 'timeMileage', null);
                        product.deductible = get(matchedCoverages[0], 'deductible', null);
                        product.displayTimeMileage = get(matchedCoverages[0], 'displayTimeMileage', null);
                      } else if(matchedCoverages.length > 1) {
                        const maxDeduct = maxBy(matchedCoverages, 'deductible');
                        product.timeMileage = get(maxDeduct, 'timeMileage', null);
                        product.deductible = get(maxDeduct, 'deductible', null);
                        product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
                      } else {
                        product.timeMileage = get(plan, 'coverageOptions[0].timeMileage', null);
                        product.deductible = get(plan, 'coverageOptions[0].deductible', null);
                        product.displayTimeMileage = get(plan, 'coverageOptions[0].displayTimeMileage', null);
                      }
                  } else if(element.dealerDefaults[0].selectedDeductible && element.dealerDefaults[0].selectedTimeMileage) {
                    matchedCoverages = plan.coverageOptions.filter(el => (el.deductible === element.dealerDefaults[0].selectedDeductible) && (el.timeMileage === element.dealerDefaults[0].selectedTimeMileage));
                    product.timeMileage = get(matchedCoverages[0], 'timeMileage', null);
                    product.deductible = get(matchedCoverages[0], 'deductible', null);
                    product.displayTimeMileage = get(matchedCoverages[0], 'displayTimeMileage', null);
                  } else {
                    const maxDeduct = maxBy(plan.coverageOptions, 'deductible');
                    product.timeMileage = get(maxDeduct, 'timeMileage', null);
                    product.deductible = get(maxDeduct, 'deductible', null);
                    product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
                  }
              }
            })
            if (!planMatched) { // If the plan from dealer defaults is not matching with any plans from the form then pick default 
              const defaultForm = element.form.filter(el => el.isDefault)[0];
              const defaultPlan = defaultForm.plans.filter(el => el.showPlanToCustomer);
              let maxDeduct = maxBy(defaultPlan[0].coverageOptions, 'deductible');
              if (!maxDeduct) {
                maxDeduct = defaultPlan[0].coverageOptions[0];
              }
              product.formId = defaultForm.id;
              product.selectedPlan = defaultPlan[0];
              product.coverage = defaultPlan[0].displayName;
              product.planCode = defaultPlan[0].planId;
              product.planName = defaultPlan[0].planName;
              product.timeMileage = get(maxDeduct, 'timeMileage', null);
              product.deductible = get(maxDeduct, 'deductible', null);
              product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
            }
        }
      } else { // dealerDefaults is empty
        const defaultForm = element.form.filter(el => el.isDefault)[0];
        const defaultPlan = defaultForm.plans.filter(el => el.showPlanToCustomer);
        let maxDeduct = maxBy(defaultPlan[0].coverageOptions, 'deductible');
        if(!maxDeduct) {
          maxDeduct = defaultPlan[0].coverageOptions[0];
        }
        product.formId = defaultForm.id;
        product.selectedPlan = defaultPlan[0];
        product.coverage = defaultPlan[0].displayName;
        product.planCode = defaultPlan[0].planId;
        product.planName = defaultPlan[0].planName;
        product.timeMileage = get(maxDeduct, 'timeMileage', null);
        product.deductible = get(maxDeduct, 'deductible', null);
        product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
      }
    } else if(element.isTermBased && element.form) { // isTermBased - true
        if(element.dealerDefaults && element.dealerDefaults.length > 0 && element.dealerDefaults.length !== 1) { // dealerDefaults is not empty
          let planMatched = false;
            element.dealerDefaults.forEach(dealerDefault => {
              if (totalMonths === dealerDefault.maxTerm || totalMonths === dealerDefault.minTerm || (totalMonths > dealerDefault.minTerm && totalMonths < dealerDefault.maxTerm)) {
                const defaultForm = element.form.filter(el => el.isDefault)[0];
                defaultForm.plans.forEach(plan => {
                  if (dealerDefault.planId === plan.planId) {
                    planMatched = true;
                    product.formId = defaultForm.id;
                    product.selectedPlan = plan;
                    product.coverage = plan.displayName;
                    product.planCode = plan.planId;
                    product.planName = plan.planName;
                    plan.coverageOptions.forEach(coverageOption => {
                      if ((totalMonths === coverageOption.minTerm) || (totalMonths === coverageOption.maxTerm) || (totalMonths > coverageOption.minTerm && totalMonths < coverageOption.maxTerm)) {
                        product.timeMileage = get(coverageOption, 'timeMileage', null);
                        product.deductible = get(coverageOption, 'deductible', null);
                        product.displayTimeMileage = get(coverageOption, 'displayTimeMileage', null);
                      }
                    })
                  }
                })

                if(!planMatched) { // If the plan from dealer defaults is not matching with any plans from the form then pick default 
                  const defaultForm = element.form.filter(el => el.isDefault)[0];
                  const defaultPlan = defaultForm.plans.filter(el => el.showPlanToCustomer);
                  let maxDeduct = maxBy(defaultPlan[0].coverageOptions, 'deductible');
                  if (!maxDeduct) {
                    maxDeduct = defaultPlan[0].coverageOptions[0];
                  }
                  product.formId = defaultForm.id;
                  product.selectedPlan = defaultPlan[0];
                  product.coverage = defaultPlan[0].displayName;
                  product.planCode = defaultPlan[0].planId;
                  product.planName = defaultPlan[0].planName;
                  product.timeMileage = get(maxDeduct, 'timeMileage', null);
                  product.deductible = get(maxDeduct, 'deductible', null);
                  product.displayTimeMileage = get(maxDeduct, 'displayTimeMileage', null);
                }
              }
            })
        } else { // isTermBased is true && dealerDefaults is empty
          const defaultForm = element.form.filter(el => el.isDefault)[0];
          const defaultPlan = defaultForm.plans.filter(el => el.showPlanToCustomer);

            product.formId = defaultForm.id;
            product.selectedPlan = defaultPlan[0];
            product.coverage = defaultPlan[0].displayName;
            product.planCode = defaultPlan[0].planId;
            product.planName = defaultPlan[0].planName;
            defaultPlan[0].coverageOptions.forEach(coverageOption => {
              if((totalMonths === coverageOption.minTerm) || (totalMonths === coverageOption.maxTerm ) || (totalMonths > coverageOption.minTerm && totalMonths <  coverageOption.maxTerm)) {
                product.timeMileage = get(coverageOption, 'timeMileage', null);
                product.deductible = get(coverageOption, 'deductible', null);
                product.displayTimeMileage = get(coverageOption, 'displayTimeMileage', null);
              }
            })     
        }
    }
    return product;
  }
  public populateAccessoryDetails(totalAddOnsCost, writupDetails) {
    totalAddOnsCost = 0;
    writupDetails.dios.filter(dt => !dt.installedFlag).forEach(dt => {
      if (!isNil(dt.updatedRetailPrice)) {
        totalAddOnsCost += dt.updatedRetailPrice * dt.units;
      }
      else if (!isNil(dt.dealerSellingPrice) && !isNaN(dt.dealerSellingPrice)) {
        if (!isNil(dt.editedSellingPrice)) {
          totalAddOnsCost += dt.editedSellingPrice * dt.units;
        }
        else {
          totalAddOnsCost += dt.dealerSellingPrice * dt.units;
        }
      }

      if (!isNil(dt.DealerSellingPrice) && !isNaN(dt.DealerSellingPrice)) {
        totalAddOnsCost += dt.DealerSellingPrice * dt.units;
      }
    });
    
  }
  dealSubmit(writupDetails, dealDofu, dealType, rateTermPayloadForDealAPI, webSocketManager, totalAddOnsCost, taxesAndFeesObject, productList, leaseType, totalMonths, isEditComp) {

    if (!isNil(writupDetails) && !isNil(writupDetails.dios)) {
      this.populateAccessoryDetails(totalAddOnsCost, writupDetails);
    }
    const dealDetails: models.DealDetails = cloneDeep({});
    if (!isNil(writupDetails) && !isNil(writupDetails.dealTransactionId)) {
      dealDetails.state = writupDetails.status;
      dealDetails.upfrontFlags = writupDetails.upfrontFlags;
      if (writupDetails?.status == 'Finalized') {
        writupDetails.status = ViewConstants.DEAL_STATUS_FINALIZED_CAP
      }
      if (writupDetails?.status == 'DFI Submitted' || writupDetails?.status == 'Dfi Submitted') {
        writupDetails.status = ViewConstants.DEAL_STATUS_DFI_SUBMITTED_CAP
      }
      dealDetails.ppUpdate = writupDetails.status;
      dealDetails['connectionId'] = webSocketManager.ConnectionID
      dealDetails.event = {};
      dealDetails.dealTermId = writupDetails.dealTermId;
      dealDetails.leadId = writupDetails.leadId;
      dealDetails.dealJacketId = writupDetails.dealJacketId;
      dealDetails.dealTransactionId = writupDetails.dealTransactionId;
      dealDetails.sourceSystem = writupDetails.sourceSystem;
      dealDetails.origin = writupDetails.origin;
      dealDetails['customerAcceptance'] = writupDetails['customerAcceptance'];
      dealDetails.status = writupDetails.status;
      dealDetails['dfiWorksheetAvailable'] = writupDetails['dfiWorksheetAvailable'];
      dealDetails.paymentType = writupDetails.paymentType;
      dealDetails.dealType = writupDetails.dealType;
      dealDetails.createdDate = writupDetails.createdDate;
      dealDetails.updatedDate = writupDetails.updatedDate;
      dealDetails.tradeInAvailability = writupDetails.tradeInAvailability;
      dealDetails.dealExpiryDate = writupDetails.dealExpiryDate;
      dealDetails.priceExpiryDate = writupDetails.priceExpiryDate;
      dealDetails.tradeInAmountApplied = writupDetails.tradeInAmountApplied;
      dealDetails.offerReadjustment = writupDetails.offerReadjustment;
      dealDetails['dealPricingSystem'] = writupDetails['dealPricingSystem'];
      dealDetails['dealPricingRefId'] = writupDetails['dealPricingRefId'];
      dealDetails['addressUpdated'] = writupDetails['addressUpdated'];
      dealDetails.securityDepositWaiverRequest = writupDetails.securityDepositWaiverRequest;
      dealDetails['customerTradeUpdated'] = writupDetails['customerTradeUpdated'];
      dealDetails['salesConsultant'] = writupDetails['salesConsultant'];
      dealDetails['leadComments'] = writupDetails['leadComments'];
      dealDetails['coBuyer'] = writupDetails['coBuyer'];
      dealDetails.salesPersonComments = writupDetails.salesPersonComments;
      dealDetails.customer = writupDetails.customer;
      dealDetails.salesAssociate = writupDetails.salesAssociate;
      dealDetails.vehicle = writupDetails.vehicle;
      dealDetails.taxesAndFees = writupDetails.taxesAndFees;
      dealDetails.incentives = writupDetails.incentives;
      dealDetails.protectionProducts = [];
      dealDetails.estimatedOffer = writupDetails.estimatedOffer;
      dealDetails.estimatedOffer.dealtype = dealDetails.estimatedOffer.offerType;
      dealDetails.customerDesiredOffer = writupDetails.customerDesiredOffer;
      dealDetails.customerDesiredOffer.dealTermId = writupDetails.dealTermId;
      dealDetails.tradeIns = writupDetails.tradeIns;
      dealDetails.dios = writupDetails.dios;
      dealDetails.isParkingLot = writupDetails.isParkingLot;
      dealDetails.vehicle.dis = this.calculateDaysInStock(
        dealDetails.vehicle.daysInStock,
        dealDetails.vehicle.invoiceDate,
        dealDetails.vehicle.vehicleTradedDate,
      );
      dealDetails.vehicle.modelName = `${dealDetails.vehicle.modelYear} ${dealDetails.vehicle.modelMarketingName}`;
      dealDetails.leadTypes = writupDetails.leadTypes;
      dealDetails.approvedOffer = {};
      dealDetails.approvedOffer.totalPpAmount = 0;

      if (writupDetails.cobuyer) {
        dealDetails.cobuyer = writupDetails.cobuyer;
      }

      if (!isNil(writupDetails.approvedOffer) && !isNil(writupDetails.approvedOffer.totalIncentives)) {
        dealDetails.approvedOffer.totalIncentives = writupDetails.approvedOffer.totalIncentives;
      }
      else if (!isNil(writupDetails.estimatedOffer) && !isNil(writupDetails.estimatedOffer.totalIncentives)) {
        dealDetails.approvedOffer.totalIncentives = writupDetails.estimatedOffer.totalIncentives;
      }

      if (!isNil(writupDetails.approvedOffer) && !isNil(writupDetails.approvedOffer.approvedCreditScore)) {
        dealDetails.approvedOffer.approvedCreditScore = this.formatDeclinationCreditRange(writupDetails.approvedOffer.approvedCreditScore);
      }
      else if (!isNil(writupDetails.estimatedOffer) && !isNil(writupDetails.estimatedOffer.selfReportedCreditScore)) {
        dealDetails.approvedOffer.approvedCreditScore = writupDetails.estimatedOffer.selfReportedCreditScore;
      }

      dealDetails.approvedOffer.totalDioAmount = totalAddOnsCost;

      if (!isNil(writupDetails.priceGrid)) {
        if (!isNil(writupDetails.priceGrid.miles)) {
          dealDetails.approvedOffer.miles = writupDetails.priceGrid.miles;
        }

        if (!isNil(writupDetails.priceGrid.vehiclePrice)) {
          dealDetails.approvedOffer.adjustedDealerSellingPrice = writupDetails.priceGrid.vehiclePrice;
        }
      }

      if (writupDetails.paymentType.toLowerCase() === ViewConstants.APR.toLowerCase()) {
        dealDetails.approvedOffer.offerType = 'APR';
      } else if (writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
        dealDetails.approvedOffer.offerType = 'LEASE';
      } else if (writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_CASH.toLowerCase()) {
        dealDetails.approvedOffer.offerType = 'CASH';
      }

      if (!isNil(taxesAndFeesObject)) {

        dealDetails.approvedOffer.securityDeposit = taxesAndFeesObject.securityDeposit;
        dealDetails.approvedOffer.totalAmountDue = taxesAndFeesObject.totalAmountDueAtSigning;
        if (writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
          dealDetails.approvedOffer.dueAtSigning = taxesAndFeesObject.dueAtSigning;
        }
      }

      let offerObject = null;
      if (!isNil(writupDetails.approvedOffer) && Object.keys(writupDetails.approvedOffer).length === 0) {
        offerObject = 'estimatedOffer';
      }
      else {
        offerObject = 'approvedOffer';
      }

      dealDetails.approvedOffer.totalMonths = writupDetails[offerObject].totalMonths;
      dealDetails.approvedOffer.cashDown = writupDetails[offerObject].cashDown;
      dealDetails.approvedOffer.outstandingBalanceOnTradeIn = writupDetails[offerObject].outstandingBalanceOnTradeIn;
      dealDetails.approvedOffer.monthlyPayment = writupDetails[offerObject].monthlyPayment ? writupDetails[offerObject].monthlyPayment : writupDetails.estimatedOffer.monthlyPayment;
      dealDetails.approvedOffer.totalAmountFinanced = writupDetails[offerObject].totalAmountFinanced ? writupDetails[offerObject].totalAmountFinanced : writupDetails.estimatedOffer.totalAmountFinanced;
      dealDetails.approvedOffer.totalDownPayment = writupDetails[offerObject].totalDownPayment ? Number(writupDetails[offerObject].totalDownPayment) : Number(writupDetails.estimatedOffer.totalDownPayment);

      dealDetails.approvedOffer.aprOrRCR = writupDetails[offerObject].aprOrRCR;

      dealDetails.approvedOffer.netCapitalizedCost = writupDetails[offerObject].netCapitalizedCost ? writupDetails[offerObject].netCapitalizedCost : writupDetails.estimatedOffer.netCapitalizedCost;
      dealDetails.approvedOffer.residualValue = writupDetails[offerObject].residualValue ? writupDetails[offerObject].residualValue : writupDetails.estimatedOffer.residualValue;
      dealDetails.approvedOffer.priorCreditBalance = writupDetails[offerObject].netTradeInValue;
      dealDetails.approvedOffer.dealTermId = writupDetails.dealTermId;
      dealDetails.approvedOffer.capCostReduction = !isNil(writupDetails[offerObject].capCostReduction) ? writupDetails[offerObject].capCostReduction : null;
      dealDetails.approvedOffer.cashDownAppliedToInceptionFees = !isNil(writupDetails[offerObject].cashDownAppliedToInceptionFees) ? writupDetails[offerObject].cashDownAppliedToInceptionFees : null;
      dealDetails.approvedOffer.dueAtSigning = !isNil(writupDetails[offerObject].dueAtSigning) ? writupDetails[offerObject].dueAtSigning : null;
      dealDetails.approvedOffer.securityDeposit = !isNil(writupDetails[offerObject].securityDeposit) ? writupDetails[offerObject].securityDeposit : null;
      dealDetails.approvedOffer.totalAmountDue = !isNil(writupDetails[offerObject].totalAmountDue) ? writupDetails[offerObject].totalAmountDue : null;

      // below values take directly from estimated and keep in approved"
      dealDetails.approvedOffer.dealtype = !isNil(writupDetails['estimatedOffer'].dealtype) ? writupDetails['estimatedOffer'].dealtype : null;
      dealDetails.approvedOffer.dealerSellingPrice = !isNil(writupDetails['estimatedOffer'].dealerSellingPrice) ? writupDetails['estimatedOffer'].dealerSellingPrice : null;
      dealDetails.approvedOffer.rateExpiryDate = !isNil(writupDetails['estimatedOffer'].rateExpiryDate) ? writupDetails['estimatedOffer'].rateExpiryDate : null;
      dealDetails.approvedOffer.tradeAmount = !isNil(writupDetails['estimatedOffer'].tradeAmount) ? writupDetails['estimatedOffer'].tradeAmount : null;
      dealDetails.approvedOffer.selfReportedCreditScore = !isNil(writupDetails['estimatedOffer'].selfReportedCreditScore) ? writupDetails['estimatedOffer'].selfReportedCreditScore : null;

      if (writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
        dealDetails.approvedOffer.totalAmountFinanced = writupDetails[offerObject].netCapitalizedCost ? writupDetails[offerObject].netCapitalizedCost : writupDetails.estimatedOffer.netCapitalizedCost;
        dealDetails.approvedOffer.securityDepositWaiverReason = writupDetails[offerObject].securityDepositWaiverReason;
        dealDetails.approvedOffer.baseMonthlyPayment = writupDetails[offerObject].baseMonthlyPayment ? writupDetails[offerObject].baseMonthlyPayment : writupDetails.estimatedOffer.baseMonthlyPayment;
        if (writupDetails.leaseType.toLowerCase() === ViewConstants.ONE_PAY_LEASE.toLowerCase()) {
          dealDetails.approvedOffer.totalMonthlyPayments = writupDetails[offerObject].totalMonthlyPayments ? writupDetails[offerObject].totalMonthlyPayments : writupDetails.estimatedOffer.totalMonthlyPayments
        }
      }


      dealDetails.dealTermComments = writupDetails.dealTermComments;
      dealDetails.lead = writupDetails.lead;
      dealDetails['salesManagerPriceHistoryLatest'] = writupDetails['salesManagerPriceHistoryLatest'];
      dealDetails['dds'] = writupDetails['dds'];
      dealDetails.priceGrid = writupDetails.priceGrid;

      dealDetails['salesManager'] = {};
      dealDetails['salesManager'].actedBy = this.sharedDataService.managerName;
      dealDetails['leaseType'] = writupDetails['leaseType'];

      let taxesAndFees: any; // getting the Updated taxes and fees
      if (typeof dealDetails.taxesAndFees.capitalizedTaxes == 'undefined' && writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
        dealDetails.taxesAndFees['capitalizedTaxes'] = []
      }

      if (typeof dealDetails.taxesAndFees.capitalizedFees == 'undefined' && writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
        dealDetails.taxesAndFees['capitalizedFees'] = []
      }
      if (typeof dealDetails.taxesAndFees.nonCapitalizedFees == 'undefined' && writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
        dealDetails.taxesAndFees['nonCapitalizedFees'] = []
      }
      if (typeof dealDetails.taxesAndFees.nonCapitalizedTaxes == 'undefined' && writupDetails.paymentType.toLowerCase() === ViewConstants.DEAL_TYPE_LEASE.toLowerCase()) {
        dealDetails.taxesAndFees['nonCapitalizedTaxes'] = []
      }

      if (writupDetails && writupDetails.protectionProducts && writupDetails.protectionProducts.length > 0) {
        writupDetails.protectionProducts.forEach(writeUpDetailProduct => {
          productList.forEach(product => {
            if (writeUpDetailProduct.productCode === product.productId) {
              product.writeUpDetailProduct = writeUpDetailProduct;
            }
          });
        });
      }

      if (!isNil(rateTermPayloadForDealAPI)) {
        const payload = cloneDeep(rateTermPayloadForDealAPI);
        dealDetails.event = { ...payload.latestProduct };
        if (!isNil(productList)) {
          productList.forEach(product => {
            if (!isNil(payload.dealerAddOns)) {
              let protectionProduct: any;
              if (product.providerId && (product.providerId.toLowerCase() !== ViewConstants.NON_TMIS.toLowerCase() || this.sharedDataService.nonToyotaProviderId.indexOf(product.providerId.toLowerCase()) > -1 || product.providerId.toLowerCase() === ViewConstants.GSFS.toLowerCase())) {
                protectionProduct = payload.dealerAddOns.filter((dealerAddOn) => (dealerAddOn.productCode === product.productId || dealerAddOn.name === product.productName));
              } else if (product.providerId && product.providerId.toLowerCase() === ViewConstants.NON_TMIS.toLowerCase()) {
                protectionProduct = payload.dealerAddOns.filter((dealerAddOn) => (dealerAddOn.planCode === product.productId || dealerAddOn.name === product.productName));
              }

              if (protectionProduct && protectionProduct.length > 0) {
                let productCode: any;
                let productDesc: any;
                let productName: any;
                if (product.providerId && (product.providerId.toLowerCase() !== ViewConstants.NON_TMIS.toLowerCase() || this.sharedDataService.nonToyotaProviderId.indexOf(product.providerId.toLowerCase()) > -1 || product.providerId.toLowerCase() === ViewConstants.GSFS.toLowerCase())) {
                  productCode = protectionProduct[0].productCode;
                  productDesc = protectionProduct[0].productDesc;
                  productName = protectionProduct[0].productName;
                } else if (product.providerId && product.providerId.toLowerCase() === ViewConstants.NON_TMIS.toLowerCase()) {
                  productCode = protectionProduct[0].productCode;
                  productDesc = protectionProduct[0].productCode;
                  productName = protectionProduct[0].name;
                }

                const DealprotectionProd: any = {
                  productName: productName,
                  productCode: productCode,
                  productDesc: productDesc,
                  dealerSellingPrice: protectionProduct[0].salePrice ? protectionProduct[0].salePrice : (product.writeUpDetailProduct ? product.writeUpDetailProduct.dealerSellingPrice : 0),
                  residualValue: protectionProduct[0].residualValue,
                  capitalizable: (protectionProduct[0].capitalized || leaseType === 'zero' || leaseType === 'first') ? true : false,
                  taxable: (protectionProduct[0].taxable) ? true : false,
                  planName: product.writeUpDetailProduct && product.writeUpDetailProduct.planName ? product.writeUpDetailProduct.planName : (protectionProduct[0].planName ? protectionProduct[0].planName : ''),
                  planCode: product.writeUpDetailProduct && product.writeUpDetailProduct.planCode ? product.writeUpDetailProduct.planCode : (protectionProduct[0].planCode ? protectionProduct[0].planCode : ''),
                  customerSelected: true,
                  // showToCustomer: product.writeUpDetailProduct && product.writeUpDetailProduct.showToCustomer ?  product.writeUpDetailProduct.showToCustomer : false,
                  grossProfit: product.writeUpDetailProduct && product.writeUpDetailProduct.grossProfit ? product.writeUpDetailProduct.grossProfit : null,
                  monthlyCost: protectionProduct[0].monthlyCost,
                  provider: product.writeUpDetailProduct && product.writeUpDetailProduct.provider ? product.writeUpDetailProduct.provider : product.providerId,
                  options: product.writeUpDetailProduct && product.writeUpDetailProduct.options ? [...product.writeUpDetailProduct.options] : [],
                  formId: protectionProduct[0].formId
                }
                if(isEditComp){
                  if (protectionProduct[0].selectedTimeMileage !== undefined) { 
                    DealprotectionProd.timeMileage = protectionProduct[0].selectedTimeMileage
                  } else {
                    DealprotectionProd.timeMileage = product.writeUpDetailProduct ? product.writeUpDetailProduct.timeMileage: ''
                  }
                  if (protectionProduct[0].selectedDeductible !== undefined) { 
                    DealprotectionProd.deductible = protectionProduct[0].selectedDeductible
                  } else {
                    DealprotectionProd.deductible = product.writeUpDetailProduct ? product.writeUpDetailProduct.deductible: ''
                  }
                }else{
                  DealprotectionProd.timeMileage = protectionProduct[0].selectedTimeMileage ? protectionProduct[0].selectedTimeMileage : (product.writeUpDetailProduct ? product.writeUpDetailProduct.timeMileage : '');
                  DealprotectionProd.deductible = protectionProduct[0].selectedDeductible ? protectionProduct[0].selectedDeductible : (product.writeUpDetailProduct ? product.writeUpDetailProduct.deductible : '');
                }

                if (product.providerId.toLowerCase() !== ViewConstants.NON_TMIS.toLowerCase() ||
                  this.sharedDataService.nonToyotaProviderId.indexOf(product.providerId.toLowerCase()) > -1 ||
                  product.providerId.toLowerCase() === ViewConstants.GSFS.toLowerCase() ||
                  product.providerId.toLowerCase() === ViewConstants.NON_TMIS.toLowerCase()) {
                  DealprotectionProd.showToCustomer = product.writeUpDetailProduct ? (product.writeUpDetailProduct.showToCustomer ? product.writeUpDetailProduct.showToCustomer : false) : product.showProductToCustomer;
                }

                dealDetails.protectionProducts.push(DealprotectionProd);
              } else {
                if (writupDetails.protectionProducts && writupDetails.protectionProducts.length > 0) { // If PP aray in deal Response is not empty
                  const productCode = product.writeUpDetailProduct && product.writeUpDetailProduct.productCode ? product.writeUpDetailProduct.productCode : '';
                  const productName = product.writeUpDetailProduct && product.writeUpDetailProduct.productName ? product.writeUpDetailProduct.productName : product.productName;
                  let productDesc: any;
                  if (product.providerId && (product.providerId.toLowerCase() !== ViewConstants.NON_TMIS.toLowerCase() || this.sharedDataService.nonToyotaProviderId.indexOf(product.providerId.toLowerCase()) > -1 || product.providerId.toLowerCase() === ViewConstants.GSFS.toLowerCase())) {
                    productDesc = productCode;
                  } else if (product.providerId && product.providerId.toLowerCase() === ViewConstants.NON_TMIS.toLowerCase()) {
                    productDesc = product.writeUpDetailProduct && product.writeUpDetailProduct.productDesc ? product.writeUpDetailProduct.productDesc : '';
                  }
                  const DealprotectionProd: any = {
                    productName: productName,
                    productCode: productCode,
                    productDesc: productDesc,
                    dealerSellingPrice: product.writeUpDetailProduct && product.writeUpDetailProduct.dealerSellingPrice ? product.writeUpDetailProduct.dealerSellingPrice : 0,
                    residualValue: product.writeUpDetailProduct && product.writeUpDetailProduct.residualValue ? product.writeUpDetailProduct.residualValue : 0,
                    capitalizable: ((product.writeUpDetailProduct && product.writeUpDetailProduct.capitalizable) || leaseType === 'zero' || leaseType === 'first') ? true : false,
                    taxable: (product.writeUpDetailProduct && product.writeUpDetailProduct.taxable) ? true : false,
                    timeMileage: (product.writeUpDetailProduct && product.writeUpDetailProduct.timeMileage) ? product.writeUpDetailProduct.timeMileage : '',
                    deductible: (product.writeUpDetailProduct && product.writeUpDetailProduct.deductible) ? product.writeUpDetailProduct.deductible : '',
                    planName: product.writeUpDetailProduct && product.writeUpDetailProduct.planName ? product.writeUpDetailProduct.planName : '',
                    planCode: product.writeUpDetailProduct && product.writeUpDetailProduct.planCode ? product.writeUpDetailProduct.planCode : '',
                    customerSelected: false,
                    // showToCustomer: product.writeUpDetailProduct && product.writeUpDetailProduct.hasOwnProperty('showToCustomer') ? product.writeUpDetailProduct.showToCustomer : product.showProductToCustomer,
                    grossProfit: product.writeUpDetailProduct && product.writeUpDetailProduct.grossProfit ? product.writeUpDetailProduct.grossProfit : null,
                    monthlyCost: product.writeUpDetailProduct && product.writeUpDetailProduct.monthlyCost ? product.writeUpDetailProduct.monthlyCost : 0,
                    provider: product.writeUpDetailProduct && product.writeUpDetailProduct.provider ? product.writeUpDetailProduct.provider : product.providerId,
                    options: product.writeUpDetailProduct && product.writeUpDetailProduct.options ? [...product.writeUpDetailProduct.options] : [],
                    formId: product.writeUpDetailProduct && product.writeUpDetailProduct.formId ? product.writeUpDetailProduct.formId : null
                  }

                  if (product.providerId.toLowerCase() !== ViewConstants.NON_TMIS.toLowerCase() ||
                    this.sharedDataService.nonToyotaProviderId.indexOf(product.providerId.toLowerCase()) > -1 ||
                    product.providerId.toLowerCase() === ViewConstants.GSFS.toLowerCase() ||
                    product.providerId.toLowerCase() === ViewConstants.NON_TMIS.toLowerCase()) {
                    DealprotectionProd.showToCustomer = product.writeUpDetailProduct ? (product.writeUpDetailProduct.showToCustomer ? product.writeUpDetailProduct.showToCustomer : false) : product.showProductToCustomer;
                  }

                  dealDetails.protectionProducts.push(DealprotectionProd);
                } else { // If PP aray in deal Response is EMPTY

                  const productCode = product.writeUpDetailProduct && product.writeUpDetailProduct.productCode ? product.writeUpDetailProduct.productCode : product.productId;
                  const productName = product.writeUpDetailProduct && product.writeUpDetailProduct.productName ? product.writeUpDetailProduct.productName : product.productName;

                  const DealprotectionProd: any = {
                    productName: productName,
                    productCode: productCode,
                    productDesc: productCode,
                    capitalizable: product.isCapitalized || leaseType === 'zero' || leaseType === 'first' ? true : false,
                    taxable: product.isTaxable ? product.isTaxable : false,
                    customerSelected: false,
                    provider: product.writeUpDetailProduct && product.writeUpDetailProduct.provider ? product.writeUpDetailProduct.provider : product.providerId,
                    options: product.writeUpDetailProduct && product.writeUpDetailProduct.options ? [...product.writeUpDetailProduct.options] : [],
                    formId: product.form[0] && product.form[0].id ? product.form[0].id : null
                  }

                  if (product.providerId.toLowerCase() !== ViewConstants.NON_TMIS.toLowerCase() ||
                    this.sharedDataService.nonToyotaProviderId.indexOf(product.providerId.toLowerCase()) > -1 ||
                    product.providerId.toLowerCase() === ViewConstants.GSFS.toLowerCase() ||
                    product.providerId.toLowerCase() === ViewConstants.NON_TMIS.toLowerCase()) {
                    DealprotectionProd.showToCustomer = product.writeUpDetailProduct ? (product.writeUpDetailProduct.showToCustomer ? product.writeUpDetailProduct.showToCustomer : false) : product.showProductToCustomer;
                  }

                  const defaultDetails = this.getDefaultPlanDetails(product, totalMonths, dealType);
                  DealprotectionProd.formId = defaultDetails.formId;
                  DealprotectionProd.planName = defaultDetails.coverage; // Temporary instead of planName
                  DealprotectionProd.planCode = defaultDetails.planCode;
                  DealprotectionProd.timeMileage = defaultDetails.timeMileage;
                  DealprotectionProd.displayTimeMileage = defaultDetails.displayTimeMileage;
                  DealprotectionProd.deductible = defaultDetails.deductible;
                  DealprotectionProd.coverage = defaultDetails.coverage;
                  DealprotectionProd.residualValue = 0;
                  DealprotectionProd.grossProfit = null;
                  dealDetails.protectionProducts.push(DealprotectionProd);
                }
              }
            }
          });
        }

        if (dealDetails && dealDetails.protectionProducts && dealDetails.protectionProducts.length > 0) {
          let totalPPAmountCount = 0;
          dealDetails.protectionProducts.forEach((product: any) => {

            productList.forEach(dfiProduct => {
              if (product.productCode === dfiProduct.productId) {
                product.isLessOrEqualMonths = dfiProduct.isLessOrEqualMonths;
                product.isTermBased = dfiProduct.isTermBased;
                if (dfiProduct.form && dfiProduct.form.length > 0) {
                  dfiProduct.form.forEach(form => {
                    form.plans.forEach(plan => {
                      if (product.planCode === plan.planId) {
                        plan.coverageOptions.forEach(coverageOption => {
                          if (product.deductible && product.deductible === coverageOption.deductible && product.timeMileage === coverageOption.timeMileage) {
                            product.displayTimeMileage = coverageOption.displayTimeMileage;
                          } else if (product.timeMileage === coverageOption.timeMileage) {
                            product.displayTimeMileage = coverageOption.displayTimeMileage;
                          }
                        })
                      }
                    })
                  })
                } else {
                  product.displayTimeMileage = '';
                }
                if (dfiProduct.dealerDefaults && dfiProduct.dealerDefaults.length > 0) {
                  dfiProduct.dealerDefaults.forEach(dealerDefault => {
                    if (totalMonths === dealerDefault.maxTerm || totalMonths === dealerDefault.minTerm || (totalMonths > dealerDefault.minTerm && totalMonths < dealerDefault.maxTerm)) {
                      product.maxTerm = dealerDefault.maxTerm;
                    }
                  })
                } else {
                  product.maxTerm = totalMonths;
                }
              }
            });

            if (product.customerSelected && product.dealerSellingPrice !== undefined) {
              totalPPAmountCount += product.dealerSellingPrice;
            }
          })
          dealDetails.approvedOffer.totalPpAmount = totalPPAmountCount;
        }
        dealDetails.deskingId = this.sharedDataService?.deskingId;
        dealDetails.deskingStatusMessage = this.sharedDataService?.deskingStatusMessage;

        let data = {};
        data = {
          "dealerCode": null,
          "dealTransactionId": writupDetails.dealTransactionId,
          "dealDetails": dealDetails,
        };
        if (dealDetails.vehicle.type === ViewConstants.VEHICLE_TYPE_CERTIFIED ||
          dealDetails.vehicle.type === ViewConstants.VEHICLE_TYPE_USED) {
          if (!isNil(dealDofu)) {
            data["dofu"] = dealDofu;
          }
        }
        this._store.dispatch(new DealUpdateWithPP(data));
      }
    }
  }
}